import { render, staticRenderFns } from "./ReplacePassword.vue?vue&type=template&id=56366ec7&scoped=true"
import script from "./ReplacePassword.vue?vue&type=script&lang=js"
export * from "./ReplacePassword.vue?vue&type=script&lang=js"
import style0 from "./ReplacePassword.vue?vue&type=style&index=0&id=56366ec7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56366ec7",
  null
  
)

export default component.exports